import TextCreate from 'core/display/simple/Text'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'

export default class ButtonBetText extends TextCreate{
  constructor(data) {
    super(data)

    const bets = game.models.BetModel.getList()
    this.name = data.name.split('-')[0]
    this.payload = parseInt(data.name.split('-')[1])
    signal.on('MODEL:BET', () => {
      if (this.payload > bets.length - 1){
        this.text.visible = false
      }
      else {
        this.update(FormatService.currency(bets[this.payload], false))
      }
    })
  }
}
